export const DEFAULT_AMENITY_LUCIDE_ICON = 'building-2';

export const AMENITY_ICON_RULES: Array<{ re: RegExp; icon: string }> = [
  { re: /covered\s+parking|underground\s+parking|basement\s+parking/i, icon: 'warehouse' },
  { re: /club\s*house|clubhouse|community\s+hall|function\s+room|party\s+hall/i, icon: 'landmark' },
  { re: /prayer|mosque|musalla|muslim|islamic/i, icon: 'moon-star' },
  { re: /jogging|jog\s+track|run\s+track|running\s+track|\bjog\b/i, icon: 'activity' },
  { re: /walk(ing)?\s+path|walkway|promenade|pedestrian|trail\b|track\s+walk/i, icon: 'route' },
  {
    re: /sports?\s+ground|tennis|padel|basketball|football\s+pitch|squash|badminton|multi-?sport|sports?\s+court/i,
    icon: 'volleyball',
  },
  { re: /bbq|barbecue|barbeque|\bgrill\b|grilling/i, icon: 'flame' },
  { re: /retail|boutique|\bshops?\b|\bmall\b|storefront|supermarket|grocery/i, icon: 'store' },
  { re: /(kids?|children)\s+play|playground|nursery|creche|play\s+area|toddler/i, icon: 'toy-brick' },
  { re: /swimming|pool|swim|plunge|jacuzzi|aqua|lagoon/i, icon: 'waves' },
  { re: /gym|fitness|workout|weights?|crossfit/i, icon: 'dumbbell' },
  { re: /spa|sauna|steam/i, icon: 'sparkles' },
  { re: /garden|landscape|green|zen/i, icon: 'trees' },
  { re: /concierge|lobby|reception|housekeeping/i, icon: 'bell' },
  { re: /lift|elevator/i, icon: 'arrow-up-down' },
  { re: /parking|garage|valet/i, icon: 'parking-square' },
  { re: /wifi|broadband|internet/i, icon: 'wifi' },
  { re: /cinema|theatre|movie/i, icon: 'clapperboard' },
  { re: /rooftop|sky\s*deck|skydeck|penthouse\s+terrace|observation\s+deck/i, icon: 'sun' },
  {
    re: /lounge|deck|terrace|balcony|sitting|seating|rest|social|leisure|recreation/i,
    icon: 'armchair',
  },
  { re: /\bcctv\b|surveillance|security\s+camera|video\s+security/i, icon: 'video' },
  { re: /security|intercom|guard|gated/i, icon: 'shield' },
];

export function resolveAmenityLucideIconName(label: string): string {
  const hit = AMENITY_ICON_RULES.find((r) => r.re.test(label));
  return hit?.icon ?? DEFAULT_AMENITY_LUCIDE_ICON;
}
